import { useEffect } from "react";
import Hero from "./components/Hero";
import Services from "./components/Services";
import WhoWeServe from "./components/WhoWeServe";
import WhyChoose from "./components/WhyChoose";
import Testimonials from "./components/Testimonials";
import TrustedBy from "./components/TrustedBy";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Navigation from "./components/Navigation";

export default function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navigation />
      <Hero />
      <TrustedBy />
      <Services />
      <WhoWeServe />
      <WhyChoose />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}